import { defineMessages } from "react-intl";

const messages = defineMessages({
  autoFilled: {
    id: "activity.bulkCreateActivityModal.autoFilled",
    defaultMessage: "Autofilled",
    description: "Relationship field placeholder",
  },
  autoFillingRelationshipFieldDisabledTooltip: {
    id: "activity.bulkCreateActivityModal.autoFillingRelationshipField.disabled.tooltip",
    defaultMessage:
      "This field is disabled because its value could create inaccurate relationships when adding records in bulk.",
    description: "Tooltip for auto filling relationship field when it is disabled",
  },
  autoFillName: {
    id: "activity.bulkCreateActivityModal.autoFillName",
    defaultMessage: "{activityTypeName} with {name}",
    description: "Default activity name",
  },
  confirmButton: {
    id: "activity.bulkCreateActivityModal.confirm",
    defaultMessage:
      "{isCompleted, select, true {Log} other {Schedule}} {count, plural, one {Activity} other {Activities}}",
    description: "Schedule/Log activities button",
  },
  emptyTextForWithSkippedUsers: {
    id: "activity.bulkCreateActivityModal.field.note.emptyTextForWithSkippedUsers",
    defaultMessage:
      "Only users that have view or edit access to either the association or the activity can be mentioned",
    description:
      "Message for the Activity Note mention dropdown when some disabled users are skipped",
  },
  note: {
    id: "activity.bulkCreateActivityModal.note",
    defaultMessage:
      "Values will be filled for all activities generated. You can edit individual activities after creation.",
    description: "Note in activity creation modal",
  },
  select: {
    id: "activity.bulkCreateActivityModal.field.activityType.placeholder",
    defaultMessage: "Select",
    description: "Placeholder for the Activity Type field on the Create Activity modal",
  },
  title: {
    id: "activity.bulkCreateActivityModal.title",
    defaultMessage: "Create {count} {count, plural, one {Activity} other {Activities}}",
    description: "Title of activity creation modal",
  },
  visibility: {
    id: "activity.bulkCreateActivityModal.field.visibility",
    defaultMessage: "Visible to",
    description: "Visibility field label in Create create edit activity modal",
  },
});

export default messages;
